import React from "react";
import styles from "./HomePageSearchBar.module.css";
import place_marker from "./../../assets/place_marker_icon.png";
import camera_icon from "./../../assets/camera_icon.png";
import cart_icon from "./../../assets/shopping_cart_icon.png";
import HomePageSearchBox from "../HomePageSearchBox";
import { useNavigate } from "react-router-dom";
import ImageWithFallback from '../ImageWithFallback';

export default function HomePageSearchBar() {
  const navigate = useNavigate();
  const handleNavigateToCart = () => {
    navigate("/cart");
  };
  return (
    <div
      className={`d-flex align-items-center justify-content-evenly ${styles.bar} px-2 py-1`}
    >
      <div className="d-none d-md-flex align-items-center gap-2">
        <p className={`m-0 text-center ${styles.shippingText}`}>
          Vận chuyển <br />
          <span className="fw-bold">
            <ImageWithFallback
              loading="lazy"
              src={place_marker}
              alt="Place marker icon"
              className="ms-1"
            />
            Toàn Quốc
          </span>
        </p>
      </div>
      <div className="d-flex align-items-center gap-2">
        <HomePageSearchBox />
        <button className={`btn ${styles.camera}`}>
          <ImageWithFallback
            loading="lazy"
            src={camera_icon}
            alt="search with image"
            className="img-fluid"
          />
        </button>
      </div>
      <a>
        <button
          className={`btn ${styles.shopping_cart}`}
          onClick={handleNavigateToCart}
        >
          <ImageWithFallback
            loading="lazy"
            src={cart_icon}
            alt="check cart"
            className="img-fluid"
          />
        </button>
      </a>
    </div>
  );
}
